import React, { FC, memo } from 'react'
import Link, { LinkProps } from 'next/link'
import Tab, { TabProps } from '@sport1/news-styleguide/Tab'

type WrappedTabProps = TabProps & LinkProps & { testID?: string }

const WrappedTab: FC<WrappedTabProps> = ({ href, webTarget, webRel, ...rest }) => {
    if (href)
        return (
            <Link href={href} target={webTarget} rel={webRel?.(href)}>
                <Tab testID="link" {...rest} />
            </Link>
        )

    return <Tab testID="tab" {...rest} />
}

export default memo(WrappedTab)
